module.exports = __webpack_public_path__ + "img/star-old.2a3217ea.svg";